import { APIModel } from '@/src/models/api-model';
import { ItemType } from './item-type';
import { AssociatedUser } from '../../associated-user';
import { TemplateCategory } from './template-category';
import { TransplantCenter } from '../../transplant-center';
import { OrganGroup } from '../../organ-group';

export class Template extends APIModel {
  id!: string;
  item_body!: string;
  template_categories: Array<TemplateCategory> = [];
  template_name!: string;
  transplant_center!: TransplantCenter;
  organ_group!: OrganGroup;
  created_by!: AssociatedUser;
  updated_by!: AssociatedUser;
  disabled_by!: AssociatedUser;
  disabled_at!: string;
  disabled_by_id!: string;
  auto_apply!: boolean;
  reference_link!: string;
  organ_group_id!: string;
  transplant_center_id!: string;
  templateCategoryIds!: string[];
  notes!: string;
  duplicateItems: boolean = false;

  static fieldsToMap = {
    direct: [
      'id',
      'organ_group_id',
      'transplant_center_id',
      'item_body',
      'disabled_at',
      'disabled_by_id',
      'template_name',
      'auto_apply',
      'reference_link',
      'notes'
    ]
  }

  get templateCategoryNames(): string {
    if(!this.template_categories) return '';
    return this.template_categories.map(tc => tc.category_name).join(', ');
  }

  public toAPIPayload(): any {
    return {     
      id: this.id,
      organ_group_id: this.organ_group_id,
      transplant_center_id: this.transplant_center_id,
      template_category_ids: this.templateCategoryIds,
      item_body: this.item_body,
      disabled_at: this.disabled_at,
      template_name: this.template_name,
      auto_apply: this.auto_apply,
      reference_link: this.reference_link,
      notes: this.notes

    }
  }

  static buildFromAPI(record: any): Template {
    const row = new Template();
    record = record || {};

    this.mapFieldsDirectly<Template>(Template.fieldsToMap.direct, record, row);

    row.template_categories = [];
    if(record.template_categories) {
      record.template_categories.forEach((r: TemplateCategory) => {
        row.template_categories.push(TemplateCategory.buildFromAPI(r));
      });
    }
  
    row.templateCategoryIds = row.template_categories.map(tc => tc.id);
    row.transplant_center = TransplantCenter.buildFromAPI(record.transplant_center);
    row.organ_group = OrganGroup.buildFromAPI(record.organ_group);
    row.created_by = AssociatedUser.buildFromAPI(record.created_by);
    row.updated_by = AssociatedUser.buildFromAPI(record.updated_by);
    row.disabled_by = AssociatedUser.buildFromAPI(record.disabled_by);

    return row
  }
}